import { FC } from 'react';
import { Helmet } from '@edikk-edikk/helmet';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import bodyCss from './assets/body.module.scss';

const BodyAttributes: FC = () => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <Helmet
      bodyAttributes={{
        class: classNamesWithStyle(
          ['body', bodyCss.body],
          ['body_style-default', bodyCss.body_styleDefault],
          ['body_style-red', bodyCss.body_styleRed],
        ),
      }}
    />
  );
};

export { BodyAttributes };
